"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _useIsomorphicLayoutEffect = _interopRequireDefault(require("../../utils/use-isomorphic-layout-effect"));
var _measureHiddenNode2 = _interopRequireDefault(require("../../utils/measure-hidden-node"));
var _useWindowWidth = _interopRequireDefault(require("../../utils/use-window-width"));
var _isBreakpoint = require("../../utils/is-breakpoint");
var _auxiliaryNav = _interopRequireDefault(require("./auxiliary-nav"));
var _focusTrap = _interopRequireDefault(require("../focus-trap"));
var _hamburgerNav = _interopRequireDefault(require("./hamburger-nav"));
var _logo = _interopRequireDefault(require("./logo"));
var _menuButton = _interopRequireDefault(require("./menu-button"));
var _navItem = _interopRequireDefault(require("./nav-item"));
require("./global-nav.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /* eslint-disable complexity */
/**
 * Starbucks global navigation which includes a logo, navigation links, optional auxiliary nav, and a 'hamburger' menu button.
 * The links and auxiliary nav will be measured, and if they do not fit in the user's viewport,
 * they will be suppressed and a hamburger button shown instead. The nav links will never show
 * in viewports smaller than 768. Clicking the hamburger button opens a navigation panel
 * which shows the nav (this behavior can be turned off for custom solutions).
 */
var GlobalNav = function GlobalNav(_ref) {
  var accountButton = _ref.accountButton,
    accountNav = _ref.accountNav,
    AuxiliaryContent = _ref.auxiliaryContent,
    className = _ref.className,
    findAStorePin = _ref.findAStorePin,
    _ref$fixedWhenHamburg = _ref.fixedWhenHamburgerNavOpen,
    fixedWhenHamburgerNavOpen = _ref$fixedWhenHamburg === void 0 ? true : _ref$fixedWhenHamburg,
    hamburgerNavFooter = _ref.hamburgerNavFooter,
    _ref$hamburgerNavProp = _ref.hamburgerNavProps,
    hamburgerNavProps = _ref$hamburgerNavProp === void 0 ? {} : _ref$hamburgerNavProp,
    headerProps = _ref.headerProps,
    _ref$hideMobileBottom = _ref.hideMobileBottomShadow,
    hideMobileBottomShadow = _ref$hideMobileBottom === void 0 ? false : _ref$hideMobileBottom,
    _ref$isUserAuthentica = _ref.isUserAuthenticated,
    isUserAuthenticated = _ref$isUserAuthentica === void 0 ? false : _ref$isUserAuthentica,
    joinNowButton = _ref.joinNowButton,
    _ref$mobileNavDefault = _ref.mobileNavDefaultBreakpoint,
    mobileNavDefaultBreakpoint = _ref$mobileNavDefault === void 0 ? 'md' : _ref$mobileNavDefault,
    navAriaLabel = _ref.navAriaLabel,
    _ref$navItems = _ref.navItems,
    navItems = _ref$navItems === void 0 ? [] : _ref$navItems,
    _ref$logoProps = _ref.logoProps,
    logoProps = _ref$logoProps === void 0 ? {} : _ref$logoProps,
    _ref$menuButtonProps = _ref.menuButtonProps,
    menuButtonProps = _ref$menuButtonProps === void 0 ? {} : _ref$menuButtonProps,
    pushViewButtonLabels = _ref.pushViewButtonLabels,
    signInButton = _ref.signInButton,
    signOutButton = _ref.signOutButton,
    onHamburgerNavIsOpenChange = _ref.onHamburgerNavIsOpenChange,
    _ref$useBuiltInHambur = _ref.useBuiltInHamburgerNav,
    useBuiltInHamburgerNav = _ref$useBuiltInHambur === void 0 ? true : _ref$useBuiltInHambur,
    _ref$useCrateLayout = _ref.useCrateLayout,
    useCrateLayout = _ref$useCrateLayout === void 0 ? false : _ref$useCrateLayout,
    _ref$useHamburgerMenu = _ref.useHamburgerMenuButton,
    useHamburgerMenuButton = _ref$useHamburgerMenu === void 0 ? true : _ref$useHamburgerMenu,
    _ref$useMaxWidthLayou = _ref.useMaxWidthLayout,
    useMaxWidthLayout = _ref$useMaxWidthLayou === void 0 ? false : _ref$useMaxWidthLayou;
  var containerRef = (0, _react.useRef)();
  var logoRef = (0, _react.useRef)();
  var navLinksRef = (0, _react.useRef)();
  var width = (0, _useWindowWidth["default"])();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    desktopNavIsVisible = _useState2[0],
    setDesktopNavIsVisible = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isHamburgerNavOpen = _useState4[0],
    setIsHamburgerNavOpen = _useState4[1];
  (0, _react.useEffect)(function () {
    if (onHamburgerNavIsOpenChange) {
      onHamburgerNavIsOpenChange(isHamburgerNavOpen);
    }
  }, [isHamburgerNavOpen]);
  var showNavigationIfItFits = function showNavigationIfItFits() {
    var _containerRef$current, _containerRef$current2, _logoRef$current$clie, _logoRef$current, _measureHiddenNode$wi, _measureHiddenNode;
    if ((0, _isBreakpoint.isBelowBreakpoint)({
      width: width,
      breakpoint: mobileNavDefaultBreakpoint
    })) {
      // always switch to the mobile experience below the given breakpoint
      setDesktopNavIsVisible(false);
      return;
    }
    var containerWidth = (_containerRef$current = containerRef === null || containerRef === void 0 || (_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.clientWidth) !== null && _containerRef$current !== void 0 ? _containerRef$current : 0;
    var logoWidth = (_logoRef$current$clie = logoRef === null || logoRef === void 0 || (_logoRef$current = logoRef.current) === null || _logoRef$current === void 0 ? void 0 : _logoRef$current.clientWidth) !== null && _logoRef$current$clie !== void 0 ? _logoRef$current$clie : 0;
    var navElement = navLinksRef === null || navLinksRef === void 0 ? void 0 : navLinksRef.current;
    // measureHiddenNode returns an object with width and height
    var navLinksWidth = (_measureHiddenNode$wi = (_measureHiddenNode = (0, _measureHiddenNode2["default"])({
      node: navElement
    })) === null || _measureHiddenNode === void 0 ? void 0 : _measureHiddenNode.width) !== null && _measureHiddenNode$wi !== void 0 ? _measureHiddenNode$wi : 0;
    // Do not make the nav visible if navLinksWidth is zero -- this would mean
    // measurement did not work.
    if (navLinksWidth === 0) {
      setDesktopNavIsVisible(false);
      return;
    }
    var navFits = Boolean(containerWidth - logoWidth > navLinksWidth);
    setDesktopNavIsVisible(navFits);
    if (navFits && isHamburgerNavOpen) {
      setIsHamburgerNavOpen(false);
    }
  };
  (0, _useIsomorphicLayoutEffect["default"])(function () {
    showNavigationIfItFits();
  }, [width]);
  return /*#__PURE__*/_react["default"].createElement(_focusTrap["default"], {
    enabled: isHamburgerNavOpen
  }, /*#__PURE__*/_react["default"].createElement("header", _extends({
    // Use aria-modal to prevent screen reader from reaching
    // the main application when the hamburger nav is open.
    // aria-modal only works if this is also declared a dialog,
    // which is how the header functions when mobile nav is open.
    "aria-modal": isHamburgerNavOpen || undefined,
    className: (0, _classnames["default"])('sb-globalNav', _defineProperty({
      'sb-globalNav--fixed': isHamburgerNavOpen && fixedWhenHamburgerNavOpen
    }, className, Boolean(className))),
    role: isHamburgerNavOpen ? 'dialog' : undefined
  }, headerProps), /*#__PURE__*/_react["default"].createElement("nav", {
    "aria-label": navAriaLabel,
    className: (0, _classnames["default"])('sb-globalNav__nav bg-white', {
      'sb-globalNav--hideBottomShadow': hideMobileBottomShadow
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('sb-global-gutters', {
      'sb-global-gutters--maxWidthLayout': useMaxWidthLayout,
      'sb-globalNav--relative': useMaxWidthLayout
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex",
    ref: containerRef
  }, /*#__PURE__*/_react["default"].createElement(_logo["default"], _extends({
    isHamburgerNavOpen: isHamburgerNavOpen,
    ref: logoRef,
    setIsHamburgerNavOpen: setIsHamburgerNavOpen,
    useBuiltInHamburgerNav: useBuiltInHamburgerNav,
    useMaxWidthLayout: useMaxWidthLayout
  }, logoProps)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "sb-globalNav__wrapper ".concat(!desktopNavIsVisible ? 'hidden' : ''),
    ref: navLinksRef
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-shrink-none"
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: "flex"
  }, navItems.map(function (item, i) {
    return /*#__PURE__*/_react["default"].createElement(_navItem["default"], _extends({
      activeListItemClassName: "sb-globalNav__desktopListItem--active",
      itemClassName: "sb-globalNav__desktopListItem flex items-center",
      key: i,
      linkClassName: "sb-globalNav__desktopLink inline-block text-noUnderline text-xxs text-upper text-bold"
    }, item));
  }))), /*#__PURE__*/_react["default"].createElement(_auxiliaryNav["default"], {
    accountButton: accountButton,
    accountNav: accountNav,
    auxiliaryContent: AuxiliaryContent,
    findAStorePin: findAStorePin,
    isUserAuthenticated: isUserAuthenticated,
    joinNowButton: joinNowButton,
    layout: "desktop",
    signInButton: signInButton,
    signOutButton: signOutButton,
    useCrateLayout: useCrateLayout,
    useMaxWidthLayout: useMaxWidthLayout
  })), !desktopNavIsVisible && useHamburgerMenuButton && /*#__PURE__*/_react["default"].createElement(_menuButton["default"], {
    isHamburgerNavOpen: isHamburgerNavOpen,
    menuButtonProps: menuButtonProps,
    setIsHamburgerNavOpen: setIsHamburgerNavOpen,
    useBuiltInHamburgerNav: useBuiltInHamburgerNav
  }))), useBuiltInHamburgerNav && useHamburgerMenuButton && /*#__PURE__*/_react["default"].createElement(_hamburgerNav["default"], {
    accountButton: accountButton,
    accountNav: accountNav,
    auxiliaryContent: AuxiliaryContent,
    closeHamburgerNav: function closeHamburgerNav() {
      return setIsHamburgerNavOpen(false);
    },
    findAStorePin: findAStorePin,
    hamburgerNavFooter: hamburgerNavFooter,
    hamburgerNavProps: hamburgerNavProps,
    isHamburgerNavOpen: isHamburgerNavOpen,
    isUserAuthenticated: isUserAuthenticated,
    joinNowButton: joinNowButton,
    navItems: navItems,
    pushViewButtonLabels: pushViewButtonLabels,
    signInButton: signInButton,
    signOutButton: signOutButton
  }))));
};
var navItemShape = process.env.NODE_ENV !== "production" ? {
  /**
   * Becomes the text of the navigation link
   */
  children: _propTypes["default"].string.isRequired,
  /**
   * Optional CSS class to be applied to the `li` element wrapping the link
   */
  className: _propTypes["default"].string,
  /**
   * Optional href of the navigation link
   */
  href: _propTypes["default"].string,
  /**
   * Tag for the nav link, defaults to a standard anchor
   */
  tagName: _propTypes["default"].any,
  /**
   * Additonal optional handler applied after the default click handler
   */
  onClick: _propTypes["default"].func
} : {};
GlobalNav.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Props passed to button which links to the account section for authenticated users.
   * Only children is required; you may pass a tagName, to/href/onClick, className, etc.
   * Including this prop will place the button in a prescriptive location in desktop
   * and mobile layouts. If accountNav is provided, this prop is ignored.
   */
  accountButton: _propTypes["default"].shape({
    /**
     * Becomes the text of the button
     */
    children: _propTypes["default"].string.isRequired
  }),
  /**
   * If accountNav is provided, the global nav will render distinct submenus in desktop
   * and mobile viewports. This submenu is geared toward the starbucks.com implementation of
   * a user's account-related navigation choices, but can really have any set of links.
   */
  accountNav: _propTypes["default"].shape({
    /**
     * Becomes the text of button to open the subnav
     */
    children: _propTypes["default"].string.isRequired,
    /**
     * Additonal optional handler applied after the default click handler
     */
    onClick: _propTypes["default"].func,
    /**
     * Required array of links for the account submenu
     */
    subNavItems: _propTypes["default"].arrayOf(_propTypes["default"].shape(_objectSpread({}, navItemShape)).isRequired)
  }),
  /**
   * If you supply `auxiliaryContent` (as a reference to a React component), it will take the place
   * of the buttons which appear on the right side of the main navList in the desktop view and under
   * the main navList in the mobile view.
   * (ie. Find a Store, Sign in/out, Join now/Account).
   */
  auxiliaryContent: _propTypes["default"].elementType,
  /**
   * Optional CSS class which will be applied to the top-level header element
   */
  className: _propTypes["default"].string,
  /**
   * Props passed to the underlying <FindAStore /> component. Including this prop
   * will place the button in a prescriptive location in desktop and mobile layouts.
   */
  findAStorePin: _propTypes["default"].shape({
    className: _propTypes["default"].string,
    /**
     * All of the other props needed; you may pass a tagName, to/href/onClick, etc. Note that
     * className should be passed separately, if needed.
     */
    otherProps: _propTypes["default"].object,
    /**
     * Text, preferably in the format "Find a store", to be applied to the find a store pin link
     */
    text: _propTypes["default"].string.isRequired,
    /**
     * Optional boolean to enable an active state for the Find a Store pin
     */
    active: _propTypes["default"].bool
  }),
  /**
   * Set to false if you do not want the header element to become fixed when the hamburger nav
   * is open. Fixed position addresses some scrolling issues, but may create others, depending
   * on the layout of the consuming app.
   */
  fixedWhenHamburgerNavOpen: _propTypes["default"].bool,
  /**
   * Optional component to be rendered at the bottom of the hamburger nav, eg. to render legalese.
   */
  hamburgerNavFooter: _propTypes["default"].elementType,
  /**
   * Additional props to be spread on the hamburger nav's root element
   */
  hamburgerNavProps: _propTypes["default"].object,
  /**
   * Additional props to be spread on the header element
   */
  headerProps: _propTypes["default"].object,
  /**
   * Set to true if you do not want a drop shadow applied to the Nav in mobile mode
   */
  hideMobileBottomShadow: _propTypes["default"].bool,
  /**
   * Whether the user is signed into the application or not
   */
  isUserAuthenticated: _propTypes["default"].bool,
  /**
   * Props passed to button which links to the account create page for unauthenticated users;
   * you may pass a tagName, to/href/onClick, className, etc. Including this prop
   * will place the button in a prescriptive location in desktop and mobile layouts.
   */
  joinNowButton: _propTypes["default"].shape({
    /**
     * Text of the button
     */
    children: _propTypes["default"].string.isRequired
  }),
  /**
   * Any extra props needed for the child Logo component
   */
  logoProps: _propTypes["default"].object,
  /**
   * Props for the "hamburger" menu button
   */
  menuButtonProps: _propTypes["default"].shape({
    /**
     * A11y text applied to the menu/hamburger button if useBuiltInHamburgerNav is false
     */
    label: _propTypes["default"].string,
    /**
     * A11y text for the menu/hamburger button when the hamburger nav is closed
     */
    labelWhenClosed: _propTypes["default"].string,
    /**
     * A11y text for the menu/hamburger button when the hamburger nav is open
     */
    labelWhenOpen: _propTypes["default"].string,
    /**
     * Click handler for hamburger button. If useBuiltInHamburgerNav is true, this
     * becomes an additonal optional handler applied after the default click handler.
     */
    onClick: _propTypes["default"].func
  }),
  /**
   * Allows customization of when the mobile nav will always be shown, defaults to 'md'.
   */
  mobileNavDefaultBreakpoint: _propTypes["default"].oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  /**
   * If your app includes multiple nav elements, include an aria label to help distinguish
   * each nav region. Note that the screenreader will add the word "navigation",
   * so that term is repetitive in any aria label.
   */
  navAriaLabel: _propTypes["default"].string,
  /**
   * Array of navigation links for the main part of the nav
   */
  navItems: _propTypes["default"].arrayOf(_propTypes["default"].shape(_objectSpread(_objectSpread({}, navItemShape), {}, {
    /**
     * Array of navigation links for the push view nav
     */
    subNavItems: _propTypes["default"].arrayOf(_propTypes["default"].shape(_objectSpread({}, navItemShape)))
  }))),
  /**
   * Optional function which will be called with a single boolean argument representing
   * whether the hamburger nav is open or not; called on `isHamburgerNavOpen` change.
   */
  onHamburgerNavIsOpenChange: _propTypes["default"].func,
  /**
   * A11y text for the mobile nav view items having a button
   */
  pushViewButtonLabels: _propTypes["default"].object,
  /**
   * Props passed to button which links to the login page for unauthenticated users.
   * Only children is required; you may pass a tagName, to/href/onClick, className, etc.
   * Including this prop will place the button in a prescriptive location in desktop
   * and mobile layouts.
   */
  signInButton: _propTypes["default"].shape({
    /**
     * Becomes the text of the button
     */
    children: _propTypes["default"].string.isRequired
  }),
  /**
   * Props passed to button which lets authenticated users sign out. Only children is required;
   * you may pass a tagName, to/href/onClick, className, etc. Including this prop
   * will place the button in a prescriptive location in desktop and mobile layouts.
   */
  signOutButton: _propTypes["default"].shape({
    /**
     * Becomes the text of the navigation link
     */
    children: _propTypes["default"].string.isRequired
  }),
  /**
   * If you have a custom solution for a mobile nav, you can disable the built in
   * hamburger nav that this component provides.
   */
  useBuiltInHamburgerNav: _propTypes["default"].bool,
  /**
   * Sets the background color of the desktop accountNav appropriately
   */
  useCrateLayout: _propTypes["default"].bool,
  /**
   * When false, the hamburger menu button (and hamburger nav) will not render.
   */
  useHamburgerMenuButton: _propTypes["default"].bool,
  /**
   * When true, at a custom breakpoint (currently 1702px) everything but the logo
   * is centered in a max width container (logo hangs off to the left).
   */
  useMaxWidthLayout: _propTypes["default"].bool
} : {};
GlobalNav.displayName = 'GlobalNav';
var _default = exports["default"] = GlobalNav;